exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip---2EXln{position:absolute;color:#000;font-size:11px;background:#fff;border-radius:5px;text-shadow:rgba(0, 0, 0, .1) 1px 1px 1px;-webkit-box-shadow:rgba(0, 0, 0, .1) 1px 1px 2px 0;box-shadow:rgba(0, 0, 0, .1) 1px 1px 2px 0}.tooltip---2EXln.tooltip__defaultStyle---PCNwg{top:-6px;right:50%;border:2px solid #c2c2c2}.tooltip---2EXln.tooltip__defaultStyle---PCNwg::after{border-right:2px solid #c2c2c2;border-bottom:2px solid #c2c2c2}.tooltip---2EXln::after{content:\"\";display:block;position:absolute;width:10px;height:10px;background:#fff;-moz-transform:rotate(-135deg);-webkit-transform:rotate(-135deg)}", ""]);

// exports
exports.locals = {
	"tooltip": "tooltip---2EXln",
	"tooltip__defaultStyle": "tooltip__defaultStyle---PCNwg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/tooltip/index.scss
// module id = 730
// module chunks = 3